module.exports = __webpack_public_path__ + "static/carrierBg-f8450f321547af461bc71344778ad672.png";